import ReactGA, { EventArgs } from 'react-ga'
import { GA_SITE_ID } from 'app-constants'
import config from "../../config"

let gaInitialized: boolean | undefined
let ecommerceInitialized: boolean | undefined

// GA is not currently in use anywhere. In order to enable GA, add AnalyticService.Google to the enabledAnalytics list in app.jsx CookieContextProvider

export const init = () => {
  if (!gaInitialized) {
    ReactGA.initialize(GA_SITE_ID, {
      debug: false,
      testMode: config.IS_REACT_GA_IN_TEST_MODE
    })
    gaInitialized = true
  }
}

export const initEcommerce = () => {
  if (gaInitialized && !ecommerceInitialized) {
    ReactGA.plugin.require('ecommerce')
    ecommerceInitialized = true
  }
}

export const disable = () => {
  gaInitialized = false
  ecommerceInitialized = false
}

export const login = (id: string) => {
  if (gaInitialized) {
    ReactGA.set({ userId: id })
  }
}

export const logout = () => {
  if (gaInitialized) {
    ReactGA.set({ userId: undefined })
  }
}

export const trackPageView = (url: string) => {
  if (gaInitialized) {
    ReactGA.set({ page: url })
    ReactGA.pageview(url)
  }
}

export const trackModalView = (url: string) => {
  if (gaInitialized) {
    ReactGA.modalview(url)
  }
}

export const trackEvent = (args: EventArgs) => {
  if (gaInitialized) {
    ReactGA.event(args)
  }
}

export const trackTransaction = (args: EventArgs) => {
  if (gaInitialized) {
    initEcommerce()
    ReactGA.plugin.execute('ecommerce', 'addTransaction', args)
    ReactGA.plugin.execute('ecommerce', 'send', {})
  }
}
